
import './App.css'
import { useEffect, useState } from 'react';
import { fetchCompetitions } from './services/api';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import Comp from './components/Comp';
import HiddenReset from './components/HiddenReset';
import { iComp } from './types/competition';
const referer = window.siteVar.referer
/////////////////////////

function App() {

const [ pageData, setPageData ] = useState<iComp[]>([])
const fetchData = async () => {
  let data = await fetchCompetitions(referer)
  if ( data ) setPageData(data)
}

useEffect(() => {
  try{
     fetchData()
  }catch(e){
    console.error(e)
  }
 
},[])

  return (
  <Router basename='/competitions'>
    <Routes>
      {pageData?.map(( competition:iComp )=> {
        return (
          <Route path={ competition.url } key={ competition.url } element={ <Comp competition={competition} />} />
      )
    })}
   </Routes>
   <HiddenReset />
  </Router>
  )
}

export default App
